import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BrandConfig, captureBrandOverride, resolveBrand } from './brand.config';

@Injectable({ providedIn: 'root' })
export class BrandService {

  readonly brand: BrandConfig;

  constructor(@Inject(DOCUMENT) private document: Document) {
    captureBrandOverride(window.location.hostname, window.location.search);
    this.brand = resolveBrand(window.location.hostname);
  }

  // Swaps the global color.css <link> for the active brand's colors and
  // updates the document title/favicon. Called once at app startup.
  // No registered brand (this.brand === BLANK_BRAND, all fields '') leaves
  // the page exactly as index.html shipped it rather than writing empty
  // src/href attributes or falling back to any specific brand's assets.
  apply(): void {
    if (!this.brand.id) {
      return;
    }

    this.document.title = this.brand.titleSuffix;

    const colorLink = this.document.getElementById('brand-colors') as HTMLLinkElement;
    if (colorLink) {
      colorLink.href = this.brand.colorsCssPath;
    }

    const faviconLink = this.document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (faviconLink) {
      faviconLink.href = this.brand.logoPath;
    }
  }
}
